module.exports = __webpack_public_path__ + "media/images/brand_icons/icon_akt-66ef4695dfe71d98e5b1b576e93b3e1f.svg";